import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

// Mark "Tag Loop" de PromoDeep : silhouette de tag de prix (trou = pastille prix)
// avec une flèche en boucle (cashback / cycle d'affiliation) sur les tokens de thème
// (--app-surface-alt / --app-border-strong / --app-accent / --app-price) pour
// s'adapter automatiquement au clair/sombre sans couleurs en dur. Remplace l'ancien
// logo4.png (sac 3D) partout où la marque est affichée (header, footer, dialogues).
@Component({
    selector: 'app-brand-mark',
    template: `
    <svg class="brand-mark" [style.width.px]="size" [style.height.px]="size" viewBox="0 0 84 84" aria-hidden="true" focusable="false">
      <path d="M12 38 L38 12 C40 10 44 10 46 12 L72 38 C74 40 74 44 72 46 L46 72 C44 74 40 74 38 72 L12 46 C10 44 10 40 12 38 Z" class="brand-mark-tag" />
      <circle cx="30" cy="30" r="5.5" class="brand-mark-hole" />
      <path d="M34 52 A12 12 0 1 1 48 58" class="brand-mark-loop" />
      <path d="M46 51 L50 59 L41 60" class="brand-mark-loop" />
    </svg>
  `,
    styles: [`
    :host { display: inline-flex; flex: none; }
    .brand-mark { display: block; }
    .brand-mark-tag { fill: var(--app-surface-alt); stroke: var(--app-text-muted); stroke-width: 2; }
    .brand-mark-hole { fill: var(--app-accent); }
    .brand-mark-loop { fill: none; stroke: var(--app-price); stroke-width: 6; stroke-linecap: round; stroke-linejoin: round; }
  `],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class BrandMarkComponent {
  @Input() size = 40;
}
